import React from 'react';
import { dayjs } from 'shared/utils/date';
import { Empty } from 'antd';
import SequentialLoadingList from 'components/SequentialLoadingList';
import ResultContent from 'containers/Results/ResultsPage/ResultContent';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const ClassicReportContent = ({ report, isPrint, viewDate }) => {
  const { content, customer } = report;
  return (
    <div className="report__content">
      {content.length > 0
        ? (
          <SequentialLoadingList lazyLoad={!isPrint} height={382}>
            {content.map(item => (
              <ResultContent
                key={item.id}
                title={item.title}
                dateRange={item.filter?.dateRange || report.dateRange}
                surveyGroupId={item.filter?.surveyGroupId}
                dataSourceId={item.filter?.dataSource?.id}
                filterSegments={item.filter?.filterSegments?.filter(segment => segment.isEnabled !== false)}
                benchmarkSegments={item.filter?.benchmarkSegments}
                contentSettings={item.contentSettings}
                chartSettings={item.chartSettings}
                language={report.language}
                viewDate={viewDate}
                timeOffset={report.timeOffset}
                isPrint={isPrint}
                isReport
                includeAISummary={item.includeAISummary}
                summaryOnly={item.summaryOnly}
                reportSnapshot={{ reportId: report.id, date: dayjs(viewDate).utc().format('YYYYMMDD'), contentId: item.id }}
                allowPersonalData={customer.allowPersonalData}
              />
            ))}
          </SequentialLoadingList>
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<FormattedMessage {...messages.reportContentEmptyMessage} />}
          />
        )}
    </div>
  );
};

export default ClassicReportContent;
